module.exports = __webpack_public_path__ + "media/images/emblems/Dielsdorf-blazon-2e65e254f6833277572291228f14f768.svg";